module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cantainer"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "txt-grap"
  }, [_vm._v("已有超10,000,000用户通过AI视觉看到美牙后的自己。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticClass: "start"
  }, [_vm._v("开启变美之旅")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ai-main"
  }, [_c('ul', {
    staticClass: "plan"
  }, _vm._l((_vm.aiList), function(item) {
    return _c('li', [_c('img', {
      staticClass: "ai-img",
      attrs: {
        "src": item.url
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "details"
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("AI")]), _vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "paragraph"
    }, [_vm._v(_vm._s(item.paragraph))])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "top-txt"
  }, [_vm._v("看见你的美好，"), _c('span', {
    staticClass: "defor"
  }, [_vm._v("AI")]), _vm._v("视觉让每一帧都精彩！")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-efdebdaa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Vision/AI.vue
// module id = 675
// module chunks = 0